import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isOnboardingSetupEnabled } from '../../brain-onboarding-setup/utils/onboarding-environment';

/**
 * Allows /portal/onboarding (and onboarding-setup) on QA/local and production Brain hosts.
 */
export const onboardingQaGuard: CanActivateFn = () => {
  if (isOnboardingSetupEnabled()) {
    return true;
  }
  void inject(Router).navigate(['/portal/map']);
  return false;
};
